import React from "react"

import { EAffiliateCampaignType } from "@/modules/helpers/enum"
import type { AddressInfo } from "@/modules/types/jobs/campaign-form"

export const ALLOWED_KEYS = {
  BACKSPACE: 8,
  TAB: 9,
  ESCAPE: 27,
  ENTER: 13,
  DELETE: 46,
  CTRL_A: 65,
  HOME: 35,
  END: 35,
  LEFT: 37,
  RIGHT: 39
}

export const NUMERIC_KEYS = {
  MIN: 48,
  MAX: 57,
  NUMPAD_MIN: 96,
  NUMPAD_MAX: 105
}

export function validateNumericInput(e: React.KeyboardEvent<HTMLInputElement>) {
  const keyCode = e.keyCode
  const isAllowedKey =
    Object.values(ALLOWED_KEYS).includes(keyCode) ||
    (keyCode === ALLOWED_KEYS.CTRL_A && e.ctrlKey) ||
    (keyCode >= ALLOWED_KEYS.HOME && keyCode <= ALLOWED_KEYS.RIGHT) ||
    (keyCode >= NUMERIC_KEYS.MIN && keyCode <= NUMERIC_KEYS.MAX) ||
    (keyCode >= NUMERIC_KEYS.NUMPAD_MIN && keyCode <= NUMERIC_KEYS.NUMPAD_MAX)

  if (!isAllowedKey) {
    e.preventDefault()
  }
}

export function sanitizeNumericInput(e: React.FormEvent<HTMLInputElement>) {
  const target = e.target as HTMLInputElement
  target.value = target.value.replace(/[^0-9]/g, "")
}

export function toggleContentType(
  current: EAffiliateCampaignType[],
  type: EAffiliateCampaignType
): EAffiliateCampaignType[] {
  if (current.includes(type)) {
    const filtered = current.filter((v) => v !== type)
    return filtered.length > 0 ? filtered : current
  }
  return [...current, type]
}

/**
 * Validates address information
 * @param addressInfo - Address information to validate
 * @returns true if address info is valid (has fullName, phoneNumber, and address)
 */
export function validateAddressInfo(
  addressInfo?: { fullName?: string; phoneNumber?: string; address?: string } | AddressInfo
): boolean {
  return !!(
    addressInfo?.fullName?.trim() &&
    addressInfo?.phoneNumber?.trim() &&
    addressInfo?.address?.trim()
  )
}
